let info = {
  name: "Cristine Marquez",
  logo_name: "Cristine",
  flat_picture: require("./assets/images/portrait.png"),
  config: {
    use_cookies: true,
    navbar: {
      blur: false,
    },
  },
  description:
    "Hi! My name is Cristine Marquez and I'm a web developer, I started coding around 2019 when I was on my sabatical year and decided to enroll in a 3 months Front-End Bootcamp in Ubiqum then after that I started working as a Front-end Developer in a company for about a year, but then I've decided to continue my studies and enrolled in a vocational school in Centre d'Estudis Politécnics, my course was 'web application developer'. If you want to know more about me and my skills scroll down!",
  links: {
    linkedin: "https://www.linkedin.com/in/cristine-marquez/",
    github: "https://github.com/CristineMar",
    jsfiddle: "https://jsfiddle.net/user/fiddles/all/",
  },
  skills: [
    {
      title: "languages",
      info: ["Javascript", "CSS3", "HTML5", "JAVA"],
      icon: "fa fa-code",
    },
    {
      title: "web technologies",
      info: ["Vue.js", "Angular.js", "SCSS", "HTML5", "CSS3", "LARAVEL", "PHP"],
      icon: "fas fa-laptop-code",
    },
    {
      title: "databases",
      info: ["MySQL", "PHPMyAdmin"],
      icon: "fa fa-database",
    },
    {
      title: "operating systems & tools",
      info: ["MacOS", "Windows", "Android", "Scrum", "Firebase", "AWS S3"],
      icon: "fas fa-tools",
    },
  ],
  projects: [
    {
      name: "",
      pictures: [
        /* {
            img: require("./src/assets/portfolio/todo-application/one.png")
          } */
      ],
      technologies: ["JavaScript", "HTML5", "Netlify"],
      category: "",
      github: "",
      visit: "",
      description:
        "Todo Application was made to help me with the learning schedule and it seams was doing a great job this app helping me to organize all the daily tasks.",
    },
  ],
};
  
  export default info;
  
  
  
  